const deadlineAtDateFormatter = 'D MMMM, dddd';

export default deadlineAtDateFormatter;
